export const UserWorkStatus = {
    /**
     * 在职
     */
    ACTIVE: 1,
    /**
     * 离职
     */
    RESIGNED: 2,
    /**
     * 停职
     */
    SUSPENDED: 3,
    /**
     * 休假
     */
    ON_LEAVE: 4,
    /**
     * 待上岗
     */
    PENDING: 5,
    /**
     * 外勤
     */
    WORK_OUT: 6,
    /**
     * 申请中
     */
    APPLIED: 7
}

export const UserWorkOptions = [
    { value: UserWorkStatus.ACTIVE, label: "在职" },
    { value: UserWorkStatus.RESIGNED, label: "离职" },
    { value: UserWorkStatus.SUSPENDED, label: "停职" },
    { value: UserWorkStatus.ON_LEAVE, label: "休假" },
    { value: UserWorkStatus.PENDING, label: "待上岗" },
    { value: UserWorkStatus.WORK_OUT, label: "外勤" },
]